exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-js-switch[data-v-58fbb262]{margin:2px;font-size:16px!important}.icon[data-v-58fbb262]{vertical-align:middle}.has-tooltip[data-v-58fbb262]{cursor:help}.disabled[data-v-58fbb262]{color:#bcc3c9}", ""]);

// exports
